import React from "react"
import styled from "styled-components"

const HomePageTitle = ({ children, className = "random" }) => {
  return <Tittle className={className}>{children}</Tittle>
}

const Tittle = styled.h2`
  font-size: 42px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #071f35;
`

export default HomePageTitle
